import Footer from "@/components/Footer/Footer";
import { Navbar } from "@/components/Header/components/Navbar";
import { FOOTER_BOTTOM_LINKS } from "@/constants/footerData";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <Navbar />
      <main id="main-content">
        {children}
        <footer className="bg-accent-color-three-dark text-white max-md:pb-12">
          <div className="px-6 py-12 desktop:px-32 desktop:py-16">
            <Footer />
            {/* Footer Bottom */}
            <div className="border-t border-accent-color-two pt-6">
              <div className="flex flex-col gap-6 desktop:gap-16 desktop:flex-row desktop:justify-between">
                <div className="flex flex-col md:flex-row gap-y-6 gap-x-3 justify-center md:justify-start">
                  {FOOTER_BOTTOM_LINKS.map((link, index) => (
                    <a
                      key={link.title}
                      href={link.href}
                      className="hover:underline text-span-medium text-white text-center md:text-nowrap"
                    >
                      {link.title}
                    </a>
                  ))}
                </div>
                <div className="text-center md:text-left desktop:text-right text-span-small text-accent-color-two">
                  <p>
                    Copyright © 2026 Solomon Clinic of Plastic Surgery. All
                    Rights Reserved. Web Design and Digital Marketing by{" "}
                    <a
                      href="https://www.webtoolsgroup.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Webtools Group
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
}
